import API from '.';

export default class SourceSystem {
  /**
   * The Timezone dimension table for UDM
   * @param {int} sourceSystemId The database ID for the SourceSystem
   * @param {String} sourceSystemName The name of the SourceSystem
   * @param {String} sourceSystemDesc Description of the SourceSystem
   * @param {String} isActive 'Y' if active, 'N' if inactive
   */
  constructor({ sourceSystemId, sourceSystemName, sourceSystemDesc, isActive }) {
    this.sourceSystemId = sourceSystemId;
    this.sourceSystemName = sourceSystemName;
    this.sourceSystemDesc = sourceSystemDesc;
    this.sourceSystemIsActive = isActive.toLowerCase() === 'y' ? true : false;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/sourceSystem');
    return data.map((d) => new SourceSystem(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`sourceSystem/${id}`);
    return new SourceSystem(data);
  }

  static async getRealEstateSourceSystems() {
    const api = await API();
    const { data } = await api.get('/realEstateSourceSystems');
    return data.map((d) => new SourceSystem(d));
  }
  static async getLocationSourceSystems() {
    const api = await API();
    const { data } = await api.get('/locationSourceSystems');
    return data.map((d) => new SourceSystem(d));
  }

  static async GetSiteSourceSystems() {
    const api = await API();
    const { data } = await api.get('/siteSourceSystems');
    return data.map((d) => new SourceSystem(d));
  }
}
